import axios from "axios";

export default {
  namespaced: true,
  state: {
    isLoading: false,
    isSubmitted: false,
    lineItems: [],
    showOverlay: false,
    visibilityTimeout: null,
  },
  getters: {
    getAllLineItems: state => state.lineItems,
    getAllEssentialLineItems: state => state.lineItems.filter(item => item.variant.essential),
    getAllEssentialLineItemsQuantity: state =>
      state.lineItems
        .filter(item => item.variant.essential)
        .reduce((sum, lineItem) => sum + lineItem.quantity, 0),
    getLineItem: state => id => state.lineItems.find(item => item?.variant?.id === id),
    showOverlay: state => state.showOverlay,
    isLoading: state => state.isLoading,
    isSubmitted: state => state.isSubmitted,
    visibilityTimeout: state => state.visibilityTimeout,
  },
  actions: {
    fetchAllLineItems: ({ commit, rootState }) => {
      axios
        .get(`/${rootState.global.currentLocale}/async_cart_data`)
        .then(response => commit("setAllLineItems", response.data))
        .catch(error => flashError(error, commit));
    },
    setShowOverlay: ({ commit }, show) => commit("setShowOverlay", show),
    toggleShowOverlay: ({ commit }) => {
      commit("toggleShowOverlay");
      commit("setVisibilityTimeout", null);
    },
    addProductToCart: ({ commit, dispatch }, { variant_id, lyticsActivities = [] }) => {
      commit("setLoading");
      commit("setSubmitted", false);

      axios
        .post(`/orders/populate`, {
          variants: [{ id: variant_id }],
          format: "json",
        })
        .then(response => {
          commit("setAllLineItems", response.data);
          dispatch("showOverlayFor", 10000);
          commit("setLoading", -1);
          commit("setSubmitted", true);
          dispatch("lytics/sendLyticsActivities", lyticsActivities, { root: true });
        })
        .catch(error => {
          flashError(error, commit);
          commit("setLoading", -1);
        });
    },
    removeProductFromCart: ({ commit, dispatch }, { variant_id, lyticsActivities = [] }) => {
      commit("setLoading");
      commit("setSubmitted", false);

      axios
        .post(`/orders/decimate`, {
          variants: [{ id: variant_id }],
          format: "json",
        })
        .then(response => {
          commit("setAllLineItems", response.data);
          commit("setLoading", -1);
          commit("setSubmitted", true);
          dispatch("lytics/sendLyticsActivities", lyticsActivities, { root: true });
        })
        .catch(error => {
          flashError(error, commit);
          commit("setLoading", -1);
        });
    },
    showOverlayFor: (context, timeToShow) => {
      clearTimeout(context.state.visibilityTimeout);
      context.commit("setShowOverlay", true);
      const timeout = setTimeout(function() {
        context.commit("setShowOverlay", false);
      }, timeToShow);
      context.commit("setVisibilityTimeout", timeout);
    },
  },
  mutations: {
    setAllLineItems: (state, lineItems) => {
      state.lineItems = lineItems;
    },
    setVisibilityTimeout: (state, timeout) => (state.visibilityTimeout = timeout),
    setShowOverlay: (state, show) => (state.showOverlay = show),
    setLoading: (state, count = 1) => (state.isLoading = state.isLoading + count),
    setSubmitted: (state, boolean) => (state.isSubmitted = boolean),
    toggleShowOverlay: state => (state.showOverlay = !state.showOverlay),
  },
};

const flashError = (error, commit) =>
  commit("flashMessages/setMessages", [["error", error.response.data.error]], {
    root: true,
  });
